module.exports = __webpack_public_path__ + "img/05.13f5e9ca.png";